<template>
  <div>
      <b-card no-body class="m-0">
        <b-card-header>
          <b-row align-v="center">
            <b-col cols="auto" class="mr-auto">
              <h5 class="mb-0">Услуги исполнителя</h5>
            </b-col>
            <b-col cols="auto">
              <b-button size="sm" variant="success" @click.stop="onAdd()">
                <font-awesome-icon icon="plus" class="mr-1"/>
                Добавить
              </b-button>
            </b-col>
          </b-row>
        </b-card-header>

        <b-table
          id="tw-services"
          ref="tw_services"
          class="mb-0"
          selectable
          select-mode="single"
          selectedVariant="success"
          striped
          small
          thead-class="top-fixed-thead thead-light"
          table-class="text-small"
          responsive
          show-empty
          :empty-text="$t('message.common.emptyTable')"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-compare="sortCompare"
          no-provider-filtering
          no-provider-paging
          no-provider-sorting
        >
          <template #table-busy>
            <div class="text-center text-success my-2">
              <b-spinner class="align-middle"/>
              <strong>Загрузка</strong>
            </div>
          </template>

          <template #cell(location_work_service_id)="row">
            <b-form-select
              id="tw_service_id"
              size="sm"
              v-model="row.item.location_work_service_id"
              :options="twsOptions"
              @change="onServiceSelected(row, $event)"
            >
            </b-form-select>
          </template>

          <template #cell(quantity)="row">
            <b-form-input
              id="tw_quantity"
              size="sm"
              autocomplete="off"
              type="number"
              :min="0"
              v-model.number="row.item.quantity"
              @input="calculateServiceTotal(row.item)"
              @keydown="preventMinus"
            />
          </template>

          <template #cell(price)="row">
            <b-form-input
              id="tw_price"
              size="sm"
              autocomplete="off"
              :disabled=true
              v-model.number="row.item.price"
            />
          </template>

          <template #cell(unit)="row">
            <unit-select
              id="tw_unit"
              ref="unit_select"
              :initial-unit="row.item.unit_code"
              is-short
              v-on:selectUnit="updateUnit($event, row)"
              :key="row.item.unit_code + '-' + row.index"
              :is-disabled=true
            />
          </template>

          <template #cell(total_price)="row">
            {{priceFormat(row.item.total_price)}}
          </template>

          <template #cell(action)="row">
            <b-button size="sm" variant="danger" @click="onRemove(row)">
              <font-awesome-icon icon="trash" />
            </b-button>
          </template>
        </b-table>
        <b-card-footer footer-bg-variant="light">
          <b-row align-h="between" align-v="center">
            <b-col cols="auto" class="mr-2">
              Всего записей: <b>{{items.length}}</b>
            </b-col>
            <b-col cols="auto" class="mr-auto">
              <span
                :id="'total-sum-' + tw.id"
                :class="{'text-danger font-weight-bold': isMismatch}"
              >
              Общая сумма: <b>{{ priceFormat(totalSum) }}</b>
              </span>
              <b-tooltip
                v-if="isMismatch"
                :target="'total-sum-' + tw.id"
                variant="danger"
              >
                Сумма услуг исполнителя не совпадает с итого ({{ priceFormat(tw.total_price) }}).
              </b-tooltip>
            </b-col>
            <b-col cols="auto">
              <b-pagination
                id="tw-services-pagination"
                pills
                :total-rows="items.length"
                :per-page="perPage"
                v-model="currentPage"/>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>

  </div>
</template>

<script>
import unitStore from "../../utilites/unitStore";
import helpers from "../../utilites/helpers";
  import UnitSelect from "../Catalogs/UnitSelect";

export default {
  name: "TaskWorkerServices",
  components: { UnitSelect },
  mixins: [ unitStore, helpers ],
  props: {
    tws: {type: Array, default: () => []},
    tw: {type: Object, default: () => ({})},
    twsOptions: {type: Array, required: false, default: () => []}
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'location_work_service_id',
          label: 'Вид услуг',
          class: '',
          sortable: false,
        },
        {
          key: 'quantity',
          label: 'Количество',
          class: '',
          sortable: false,
        },
        {
          key: 'price',
          label: 'Цена',
          class: '',
          sortable: false,
        },
        {
          key: 'unit',
          label: 'Ед. изм.',
          class: '',
          sortable: false,
        },
        {
          key: 'total_price',
          label: 'Итого',
          sortable: false,
          class: 'align-middle total_price',
        },
        {
          key: 'action',
          label: "Действия",
          class: 'text-center align-middle',
          tdClass: 'align-bottom',
          sortable: false,
        },
      ],
      perPage: 10,
      currentPage: 1,
      deleteRow: {
        id: null,
        location_work_service_name: ''
      },
      sortBy: 'id',
      sortDesc: true,
    }
  },
  computed: {
    totalSum() {
      return this.items.reduce((acc, item) => acc + item.total_price, 0);
    },
    isMismatch() {
      if (this.items.length === 0) {
        return false;
      }

      return Math.abs(this.totalSum - this.tw.total_price) > 0.01;
    }
  },
  methods: {
    updateUnit(unit, row) {
      row.item.unit_code = unit.code;
    },
    onAdd() {
      const data = {
        id: 0,
        location_id: this.locationId,
        location_work_id: null,
        location_work_service_id: null,
        location_work_service_name: '',
        quantity: 0,
        price: 0,
        total_price: 0,
        unit_code: '539',
      }
      this.items.unshift(data);
      this.currentPage = 1;
    },
    onRemove(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление работы";
      const message = `Вы уверены, что хотите удалить ${this.deleteRow.location_work_service_name.toLowerCase()}?`;
      this.showModalDelete(title, message, function () {
        const index = this.items.findIndex(item => item === row.item);
        this.items.splice(index, 1);
      }.bind(this));
    },
    onServiceSelected(row, serviceId) {
      const selectedOption = this.twsOptions.find(opt => opt.value === serviceId);

      if (selectedOption) {
        const details = selectedOption.details;
        row.item.location_id = details.location_id;
        row.item.location_work_service_id = details.id;
        row.item.location_work_service_name = details.work_service_name;
        row.item.price = details.price || 0;
        row.item.unit_code = details.unit_code;
      }

      this.calculateServiceTotal(row.item);
    },
    calculateServiceTotal(item) {
      item.total_price = item.price * item.quantity;
    },
  },
  watch: {
    tws: {
      immediate: true,
      handler(newValue) {
        const newJson = JSON.stringify(newValue);
        const oldJson = JSON.stringify(this.items);

        if (newJson !== oldJson) {
          let newItems = newValue ? JSON.parse(newJson) : [];

          newItems.forEach(item => {
            if (item.total_price === undefined || null) {
              item.total_price = (item.price) * (item.quantity);
            }
          });

        this.items = newItems;
      }
    }
  },
    items: {
      deep: true,
      handler(newValue) {
        this.$emit('change', newValue);
      }
    }
  },
}
</script>

<style>
#tw-services-pagination {
  margin-bottom: 0 !important;
}

.total_price {
  font-size: small !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Tasks/TaskWorkerServices.vue